import { formatDateMedium, formatDateTo24HrTime } from "utils/timekeep";
import moment from "moment";
import { formatCurrency } from "utils/helpers";

const buildBookingConfirmation = ({
  facility,
  eventDetails,
  selectedTimeSlot,
  selectedRoom,
  additionalRequirements,
  showEndTime,
  collectEventDetails,
  showPrice,
}) => {
  let details = {
    arrivalDate: {
      label: "Date",
      value: formatDateMedium(moment.utc(eventDetails.arrivalDate.value)),
    },
    facility: {
      label: "Facility",
      value: facility?.name,
    },
    selectedRoom: { label: "Space", value: selectedRoom.title },
    start_time: {
      label: "Start Time",
      value: formatDateTo24HrTime(moment.utc(selectedTimeSlot.start_time)),
    },
    numberOfPeople: {
      label: "Number of guests",
      value: eventDetails.numberOfPeople.value,
    },
    specialRequests: {
      label: "Special requests",
      value: additionalRequirements.specialRequests.value,
    },
  };

  if (showPrice) {
    details.cost = { label: "Cost", value: formatCurrency("GBP", selectedTimeSlot.cost) };
  }

  if (showEndTime) {
    details.end_time = {
      label: "End Time",
      value: formatDateTo24HrTime(moment.utc(selectedTimeSlot.end_time)),
    };
  }

  if (collectEventDetails) {
    details.nameOfEvent = { label: "Event name", value: eventDetails.nameOfEvent.value };
    details.eventType = {
      label: "Event type",
      value: eventDetails.eventType.options.inputProps.options.find(
        (option) => option.value == eventDetails.eventType.value
      ).label,
    };
    details.companyName = { label: "Company name", value: eventDetails.companyName.value };
  }

  return details;
};

export const buildBookingConfirmationUrl = ({
  facility,
  eventDetails,
  selectedTimeSlot,
  selectedRoom,
  additionalRequirements,
  showEndTime,
  collectEventDetails,
  showPrice,
}) => {
  // NM: Data to json and Base64 encoding
  const bookingConfirmationString = encodeURIComponent(
    btoa(
      JSON.stringify(
        buildBookingConfirmation({
          facility,
          eventDetails,
          selectedTimeSlot,
          selectedRoom,
          additionalRequirements,
          showEndTime,
          collectEventDetails,
          showPrice,
        })
      )
    )
  );

  return window.location.href + `?bookingConfirmationString=${bookingConfirmationString}`;
};
